<template>
  <v-dialog max-width="500">
    <template v-slot:default="{ isActive }">
      <v-form fast-fail v-model="isFormValid" ref="form">
        <v-card title="Escalation">
          <v-card-text class="d-flex flex-column ga-2">
            <v-text-field
              :rules="[rules.required]"
              hide-details="auto"
              label="Username"
              v-model="username"
            />
            <v-text-field
              :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min]"
              :type="show1 ? 'text' : 'password'"
              hide-details="auto"
              label="Password"
              v-model="password"
              @click:append-inner="show1 = !show1"
            />
            <!-- <v-divider class="my-4" />
            <v-select
              label="Role"
              v-model="role"
              hide-details="auto"
              :items="['Volunteer', 'Program Manager', 'Admin']"
            />
            <v-select
              label="Duration"
              v-model="duration"
              hide-details="auto"
              :items="durationOptions"
              item-title="text"
              item-value="value"
            /> -->
          </v-card-text>
          <v-card-actions>
            <v-btn text="Cancel" @click="handleClose"></v-btn>
            <v-btn
              :disabled="!isFormValid"
              text="Unlock"
              color="primary"
              variant="flat"
              @click="handleUnlock"
            ></v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </template>
  </v-dialog>
</template>

<script setup lang="ts">
import { useAuthStore } from "@/stores/auth";
import { useNotificationStore } from "@/stores/notification";
import { ref } from "vue";

const authStore = useAuthStore();
const notificationStore = useNotificationStore();

const isActive = ref(false);

const rules = {
  required: (value: string) => !!value || "Required.",
  min: (v: string) => v.length >= 8 || "Min 8 characters",
  emailMatch: () => "The email and password you entered don't match",
};

// // duration in minutes
// const durationOptions = [
//   { value: 5, text: "5 Minutes" },
//   { value: 10, text: "10 Minutes" },
//   { value: 30, text: "30 Minutes" },
//   { value: 60, text: "1 hour" },
//];

const { overrideAction, closeDialog } = defineProps<{
  overrideAction?: () => void;
  closeDialog?: () => void;
}>();

const show1 = ref(false);
const username = ref<string | null>(null);
const password = ref<string | null>(null);
// const duration = ref<number>(5);
// const role = ref("");
const form = ref<HTMLFormElement | null>(null);
const isFormValid = ref(false);

const handleUnlock = async () => {
  // validate form
  const { valid } = await form.value?.validate();
  if (!valid) {
    return;
  }

  if (!authStore.escalationTokenExpired()) {
    notificationStore.addSnackbar("Already escalated");
    return;
  }
  try {
    if (username.value && password.value) {
      await authStore.escalate(username.value, password.value);

      notificationStore.addSnackbar("Permission unlocked");
      handleClose();

      // call overrideAction
      if (overrideAction) {
        overrideAction();
      }
    }
  } catch (error) {
    console.error("doAdminOverride error", error);
    // show error message
    notificationStore.addSnackbar("Error unlocking user", "error");
  }
};

const handleClose = () => {
  if (closeDialog) {
    closeDialog();
    username.value = password.value = null;
  }
  isActive.value = false;
};
</script>
